require('./categoryTableCell.scss');

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// @ constans
const { getCategoryIcon } = require('constants/categories');
// @ core
const { i18n: { FormattedText } } = require('core/i18n');
// @ components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class CategoryTableCell extends Component {

    renderEditCategory = (canBeRecategorized) => {
        if (canBeRecategorized) {
            return (
                <i
                    className="pull-right icon-s-editar category-table-cell__category-tooltip-edit-icon"
                    onClick={this.handleOpenCategoriesModal}
                />
            );
        } else {
            return (
                <FormattedText
                    className="category-table-cell__category-info-message"
                    value="accounts-cantBeCategorizedInfoMessage"
                />
            );
        }
    }

    renderContent = (category, subcategory, canBeRecategorized, showRecategorization, newCategorized) => {
        return (
            <div className="category-table-cell__category-tooltip">
                <FormattedText value={newCategorized ? `categorized-${subcategory}` : `${category}-${subcategory}`} />
                {showRecategorization && this.renderEditCategory(canBeRecategorized)}
            </div>
        )
    }

    render() {
        const {
            canBeRecategorized,
            category,
            customClassName,
            highlighted,
            showRecategorization,
            subcategory,
            iconCategory,
            newCategorized
        } = this.props;
        const categoryIcon = getCategoryIcon(category);
        const className = classNames('category-table-cell__icon', {
            'category-table-cell__icon--highlighted': highlighted,
            [customClassName]: customClassName,
            [categoryIcon]: categoryIcon
        });

        const tooltipTarget = iconCategory ? <img className="category-table-cell__icon-image" src={iconCategory} alt="explicative" /> : <i className={className} />;
        return category && (
            <OKTooltip
                iconClass={className}
                content={this.renderContent(category, subcategory, canBeRecategorized, showRecategorization, newCategorized)}
                offset={[0, -15]}
                target={tooltipTarget}
                title={newCategorized ? `categorized-${category}` : `categories-${category}`}
                type="explicative"
            />
        );
    }
}

CategoryTableCell.propTypes = {
    canBeRecategorized: PropTypes.bool,
    category: PropTypes.string,
    customClassName: PropTypes.string,
    highlighted: PropTypes.bool,
    showRecategorization: PropTypes.bool,
    subcategory: PropTypes.string,
    iconCategory: PropTypes.string,
    newCategorized: PropTypes.bool
};

CategoryTableCell.defaultProps = {
    canBeRecategorized: false,
    showRecategorization: false,
    highlighted: false,
    iconCategory: null,
    newCategorized: false
}

export default CategoryTableCell;